(function () {
  'use strict';

  if (window.AquaJoyBundleGuard) return;

  var configElement = document.getElementById('AquaJoyBundleGuardConfig');
  if (!configElement) return;

  var config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    console.error('[Bundle Guard] Invalid configuration.', error);
    return;
  }

  if (!config.mainProduct || !config.mainProduct.handle || !Array.isArray(config.gifts)) return;

  var nativeFetch = window.fetch.bind(window);
  var cartMutationPattern = /\/cart\/(add|change|update|clear)(?:\.js)?(?:[?#]|$)/i;
  var syncPromise = null;
  var syncTimer = null;
  var rerunRequested = false;
  var checkoutInProgress = false;
  var enhancementQueued = false;
  var cartRequestsInFlight = 0;
  var cartIdleResolvers = [];
  var giftHandles = config.gifts.map(function (gift) { return gift.handle; });

  function normalizeNumber(value) {
    var number = Number(value);
    return Number.isFinite(number) ? number : 0;
  }

  function rootPath(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    return root.replace(/\/$/, '') + '/' + path.replace(/^\//, '');
  }

  function requestUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function isMainProduct(item) {
    return item.handle === config.mainProduct.handle ||
      normalizeNumber(item.product_id) === normalizeNumber(config.mainProduct.productId);
  }

  function isGiftProduct(item, gift) {
    return item.handle === gift.handle ||
      normalizeNumber(item.product_id) === normalizeNumber(gift.productId) ||
      normalizeNumber(item.variant_id) === normalizeNumber(gift.variantId);
  }

  function expectedGiftQuantity(gift, mainQuantity) {
    var perMain = normalizeNumber(gift.quantityPerMain);
    var offset = normalizeNumber(gift.quantityOffset);
    return Math.max(0, Math.floor((mainQuantity * perMain) + offset));
  }

  function planCart(cart) {
    var items = Array.isArray(cart && cart.items) ? cart.items : [];
    var mainQuantity = items.reduce(function (total, item) {
      return isMainProduct(item) ? total + normalizeNumber(item.quantity) : total;
    }, 0);
    var updates = {};
    var additions = [];

    config.gifts.forEach(function (gift) {
      var expected = expectedGiftQuantity(gift, mainQuantity);
      var giftItems = items.filter(function (item) { return isGiftProduct(item, gift); });

      if (giftItems.length === 0) {
        if (expected > 0) {
          additions.push({
            id: normalizeNumber(gift.variantId),
            quantity: expected
          });
        }
        return;
      }

      giftItems.forEach(function (item, index) {
        var targetQuantity = index === 0 ? expected : 0;
        if (normalizeNumber(item.quantity) !== targetQuantity) {
          updates[item.key] = targetQuantity;
        }
      });
    });

    return {
      mainQuantity: mainQuantity,
      updates: updates,
      additions: additions,
      changed: Object.keys(updates).length > 0 || additions.length > 0
    };
  }

  function parseJsonResponse(response) {
    if (!response.ok) {
      return response.text().then(function (message) {
        throw new Error(message || ('Cart request failed with status ' + response.status));
      });
    }
    return response.json();
  }

  function cartRequest(path, body) {
    return nativeFetch(rootPath(path), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    }).then(parseJsonResponse);
  }

  function readCart() {
    return nativeFetch(rootPath('cart.js'), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept': 'application/json' }
    }).then(parseJsonResponse);
  }

  function sectionRequestData(payload) {
    payload.sections = ['cart-drawer', 'cart-icon-bubble'];
    payload.sections_url = window.location.pathname;
    return payload;
  }

  function renderCartResponse(response) {
    if (!response || !response.sections) return;

    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents(response, true);
    }

    var cartPageItems = document.querySelector('cart-items');
    if (cartPageItems && typeof cartPageItems.onCartUpdate === 'function') {
      cartPageItems.onCartUpdate();
    }

    queueEnhancements();
  }

  async function applyPlan(plan) {
    var response = null;
    var updateKeys = Object.keys(plan.updates);

    if (updateKeys.length > 0) {
      var updatePayload = { updates: plan.updates };
      if (plan.additions.length === 0) sectionRequestData(updatePayload);
      response = await cartRequest('cart/update.js', updatePayload);
    }

    if (plan.additions.length > 0) {
      response = await cartRequest('cart/add.js', sectionRequestData({ items: plan.additions }));
    }

    renderCartResponse(response);
  }

  async function syncOnce() {
    var cart = await readCart();

    for (var attempt = 0; attempt < 3; attempt += 1) {
      var plan = planCart(cart);
      if (!plan.changed) {
        queueEnhancements();
        return cart;
      }

      await applyPlan(plan);
      cart = await readCart();
    }

    var finalPlan = planCart(cart);
    if (finalPlan.changed) {
      throw new Error('The bundle quantities could not be synchronized.');
    }

    queueEnhancements();
    return cart;
  }

  function syncCart() {
    if (syncPromise) {
      rerunRequested = true;
      return syncPromise;
    }

    syncPromise = (async function () {
      var cart;
      do {
        rerunRequested = false;
        cart = await syncOnce();
      } while (rerunRequested);
      return cart;
    })();

    syncPromise = syncPromise.finally(function () {
      syncPromise = null;
    });

    return syncPromise;
  }

  function scheduleSync(delay) {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(function () {
      syncCart().catch(function (error) {
        console.error('[Bundle Guard] Cart sync failed.', error);
      });
    }, typeof delay === 'number' ? delay : 80);
  }

  function waitForCartRequests() {
    if (cartRequestsInFlight === 0) return Promise.resolve();
    return new Promise(function (resolve) {
      cartIdleResolvers.push(resolve);
    });
  }

  function finishTrackedCartRequest() {
    cartRequestsInFlight = Math.max(0, cartRequestsInFlight - 1);
    if (cartRequestsInFlight !== 0) return;
    var resolvers = cartIdleResolvers.slice();
    cartIdleResolvers = [];
    resolvers.forEach(function (resolve) { resolve(); });
  }

  function moveMainProductFirst(container) {
    if (!container) return;
    var mainItems = Array.prototype.slice.call(
      container.querySelectorAll('.cart-item--product-' + config.mainProduct.handle)
    );
    if (mainItems.length === 0) return;

    var firstElement = container.firstElementChild;
    if (mainItems[0] === firstElement) return;

    var fragment = document.createDocumentFragment();
    mainItems.forEach(function (item) { fragment.appendChild(item); });
    container.insertBefore(fragment, container.firstElementChild);
  }

  function protectGiftControls() {
    giftHandles.forEach(function (handle) {
      document.querySelectorAll('.cart-item--product-' + handle).forEach(function (item) {
        item.setAttribute('data-bundle-guard-gift', 'true');
        item.querySelectorAll('.quantity__input').forEach(function (input) {
          input.readOnly = true;
          input.tabIndex = -1;
          input.setAttribute('aria-readonly', 'true');
        });
      });
    });
  }

  function enhanceCartDom() {
    moveMainProductFirst(document.querySelector('#CartDrawer-CartItems .cart-items'));
    moveMainProductFirst(document.querySelector('#main-cart-items tbody'));
    protectGiftControls();
  }

  function queueEnhancements() {
    if (enhancementQueued) return;
    enhancementQueued = true;
    window.requestAnimationFrame(function () {
      enhancementQueued = false;
      enhanceCartDom();
    });
  }

  function showCheckoutError() {
    var errorElement = document.getElementById('AquaJoyBundleGuardError');
    if (!errorElement) {
      errorElement = document.createElement('p');
      errorElement.id = 'AquaJoyBundleGuardError';
      errorElement.setAttribute('role', 'alert');
      errorElement.style.color = '#b42318';
      errorElement.style.margin = '10px 0';
      var checkoutButton = document.querySelector('[name="checkout"]');
      if (checkoutButton && checkoutButton.parentNode) {
        checkoutButton.parentNode.insertBefore(errorElement, checkoutButton);
      } else {
        document.body.appendChild(errorElement);
      }
    }
    errorElement.textContent = 'We could not verify your bundle. Please refresh the cart and try again.';
  }

  async function guardedCheckout(button) {
    if (checkoutInProgress) return;
    checkoutInProgress = true;

    var wasDisabled = button && button.disabled;
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }

    try {
      await waitForCartRequests();
      var cart = await syncCart();
      if (planCart(cart).changed) throw new Error('Bundle verification did not finish.');
      window.location.assign(rootPath('checkout'));
    } catch (error) {
      console.error('[Bundle Guard] Checkout blocked.', error);
      checkoutInProgress = false;
      if (button) {
        button.disabled = Boolean(wasDisabled);
        button.removeAttribute('aria-busy');
      }
      showCheckoutError();
    }
  }

  function checkoutControl(target) {
    if (!target || typeof target.closest !== 'function') return null;
    return target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');
  }

  document.addEventListener('click', function (event) {
    var control = checkoutControl(event.target);
    if (!control) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    guardedCheckout(control);
  }, true);

  document.addEventListener('submit', function (event) {
    var submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    guardedCheckout(submitter);
  }, true);

  window.fetch = function () {
    var args = Array.prototype.slice.call(arguments);
    var isCartMutation = cartMutationPattern.test(requestUrl(args[0]));
    if (isCartMutation) cartRequestsInFlight += 1;

    return nativeFetch.apply(null, args).then(function (response) {
      if (isCartMutation && response.ok) scheduleSync(100);
      return response;
    }).finally(function () {
      if (isCartMutation) finishTrackedCartRequest();
    });
  };

  function init() {
    queueEnhancements();
    scheduleSync(0);

    if (typeof MutationObserver === 'function' && document.body) {
      var observer = new MutationObserver(function (records) {
        var cartContentAdded = records.some(function (record) {
          return Array.prototype.some.call(record.addedNodes, function (node) {
            if (node.nodeType !== 1) return false;
            return (node.matches && node.matches('.cart-item, #CartDrawer-CartItems, #main-cart-items')) ||
              (node.querySelector && node.querySelector('.cart-item'));
          });
        });

        queueEnhancements();
        if (cartContentAdded) scheduleSync(120);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  window.AquaJoyBundleGuard = {
    config: config,
    planCart: planCart,
    sync: syncCart,
    enhance: enhanceCartDom
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('pageshow', function () { scheduleSync(0); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') scheduleSync(0);
  });
})();
